var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('layout',{scopedSlots:_vm._u([{key:"default",fn:function(slotProps){return [_c('router-view',{attrs:{"loginState":slotProps.loginState,"isCore":slotProps.isCore}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }